import React, { createContext, useState, useContext, useEffect } from 'react';

import imgLoading from '../images/circle-loading-animation.gif';
import styled from 'styled-components';
import Wrapper from '../components/wrapper/Wrapper';

export const ImagesContext = createContext({
  images: {},
});

export const useImagesContext = () => useContext(ImagesContext);

export const ImagesProvider = (props) => {
  const [images, setImages] = useState({});
  const [imagesReadyCnt, setImagesReadyCnt] = useState(0);
  const { r } = props;

  // import and preload images
  useEffect(() => {
    const importedImages = {};
    let i = 0;
    r.keys().forEach((item) => {
      const importedImg = r(item);
      const temp = item.replace(/(.*\/).*/g, (m, g1) => g1);
      importedImages[item.replace(temp, '')] = importedImg;
      i++;
      setImagesReadyCnt(i);
      const img = new Image();
      // img.onload = () => {
      //   i++;
      //   console.debug(item, importedImg, `${i} images loaded`);
      //   setImagesReadyCnt(i);
      // };
      img.src = importedImg;
    });
    setImages(importedImages);
  }, [r]);

  // console.debug("images", Object.keys(images).length, imagesReadyCnt);

  if (Object.keys(images).length !== imagesReadyCnt || imagesReadyCnt < 1) {
    return (
      // <Background className={props.intro ? 'intro' : ''}>
      // <Loader />
      // </Background>
      // <h1>Loading</h1>
      <Wrapper>
        <Loading
          src={imgLoading}
          onContextMenu={(e) => e.preventDefault()}
          alt=""
        />
        {/* <Loading /> */}
      </Wrapper>
    );
  }

  if (props.intro) {
    return (
      // <Background className="intro">
      <ImagesContext.Provider value={{ images }}>
        {props.children}
      </ImagesContext.Provider>
      // </Background>
    );
  }

  return (
    <ImagesContext.Provider value={{ images }}>
      {props.children}
    </ImagesContext.Provider>
  );
};

const Loading = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ImagesConsumer = ImagesContext.Consumer;
